var React = require('react');

function CalendarInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.375 3H3.625C2.93464 3 2.375 3.55964 2.375 4.25V13C2.375 13.6904 2.93464 14.25 3.625 14.25H12.375C13.0654 14.25 13.625 13.6904 13.625 13V4.25C13.625 3.55964 13.0654 3 12.375 3Z","stroke":"#3F3E3E","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.5 1.75V4.25","stroke":"#3F3E3E","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M5.50073 1.75V4.25","stroke":"#3F3E3E","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M2.375 6.75H13.625","stroke":"#3F3E3E","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

CalendarInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CalendarInline;

CalendarInline.default = CalendarInline;
